import { render, staticRenderFns } from "./GoogleLogin.vue?vue&type=template&id=3967ba9a&"
import script from "./GoogleLogin.vue?vue&type=script&lang=js&"
export * from "./GoogleLogin.vue?vue&type=script&lang=js&"
import style0 from "./GoogleLogin.vue?vue&type=style&index=0&id=3967ba9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports